import { gsap } from 'gsap'

document.addEventListener("DOMContentLoaded", function() {
  const circleExplore = document.querySelector(".js-cursor-circle-explore");
  const circleSwipe = document.querySelector(".js-cursor-circle-swipe");
  const sectionsExplore = document.querySelectorAll(".js-move-circle-to-cursor-explore");
  const sectionsSwipe = document.querySelectorAll(".js-move-circle-to-cursor-swipe");


  // Explore circle
  function moveCircleExplore(event) {
    gsap.to(circleExplore, {
      x: event.clientX - circleExplore.width / 2,
      y: event.clientY - circleExplore.height / 2,
      duration: 0.6,
    });
  }

  function setCircleExplore(event) {
    gsap.set(circleExplore, {
      x: event.clientX - circleExplore.width / 2,
      y: event.clientY - circleExplore.height / 2,
    });
  }

  sectionsExplore.forEach(section => {

    section.addEventListener("mouseenter", function(e) {
      //$(circle).fadeIn(200)
      setCircleExplore(e)
      gsap.to(circleExplore, {
	      opacity: 1,
	      display: 'block',
	      duration: 0.2,
	    });
	    document.addEventListener("mousemove", moveCircleExplore);
    });

    section.addEventListener("mouseleave", function() {
    	//gsap.killTweensOf(circle)
      gsap.to(circleExplore, {
	      opacity: 0,
	      display: 'none',
	      duration: 0.2,
	    });
	    document.removeEventListener("mousemove", moveCircleExplore);
    });


  });


	// Swipe circle
	function moveCircleSwipe(event) {
    gsap.to(circleSwipe, {
      x: event.clientX - circleSwipe.width / 2,
      y: event.clientY - circleSwipe.height / 2,
      duration: 0.6,
    });
  }

  function setCircleSwipe(event) {
    gsap.set(circleSwipe, {
      x: event.clientX - circleSwipe.width / 2,
      y: event.clientY - circleSwipe.height / 2,
    });
  }

  sectionsSwipe.forEach(section => {

    section.addEventListener("mouseenter", function(e) {
      //$(circle).fadeIn(200)
      setCircleSwipe(e)
      gsap.to(circleSwipe, {
	      opacity: 1,
	      display: 'block',
	      duration: 0.2,
	    });
	    document.addEventListener("mousemove", moveCircleSwipe);
    });

    section.addEventListener("mouseleave", function() {
    	//gsap.killTweensOf(circle)
      gsap.to(circleSwipe, {
	      opacity: 0,
	      display: 'none',
	      duration: 0.2,
	    });
	    document.removeEventListener("mousemove", moveCircleSwipe);
    });


  });



});